import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setMember(res.data))
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email) => {
    const res = await api.post("/auth/login", { email });
    localStorage.setItem("token", res.data.token);
    setMember(res.data.member);
    return res.data.member;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setMember(null);
  };

  const refresh = async () => {
    try { const res = await api.get("/auth/me"); setMember(res.data); } catch (e) { console.error("Auth refresh failed", e); }
  };

  return (
    <AuthContext.Provider value={{ member, loading, login, logout, refresh, role: member?.role }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export const ROLE_LABELS = {
  admin: "Admin (AI Lead)",
  it_admin: "IT Admin",
  team_lead: "Partner",
  member: "Member",
};
